import { useCallback, useEffect, useRef, useState } from 'react';

export default function useToast(duration = 2800) {
    const [toast, setToast] = useState(null);
    const timerRef = useRef(null);

    const clearToast = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setToast(null);
    }, []);

    const showToast = useCallback(
        (message) => {
            if (!message) return;
            setToast(message);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                clearToast();
            }, duration);
        },
        [clearToast, duration]
    );

    useEffect(() => () => clearToast(), [clearToast]);

    return { toast, showToast, clearToast };
}


